import { useEffect, useState } from "react";
import { CheckCircle2, CircleDashed, XCircle } from "lucide-react";
import { formatDate, useApi } from "@/lib/api";

// Last real Graph call made by MUSORA for each requested Meta permission (App Review evidence). Never shows tokens.
export function MetaApiCalls({ tid, refreshKey }) {
  const api = useApi();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/t/${tid}/lead-platforms/meta/api-calls`).then(({ data }) => setRows(data.permissions)).catch(() => setRows(null)); }, [api, tid, refreshKey]);
  if (!rows) return null;
  return (
    <details className="rounded border border-slate-200 px-2 py-1.5 text-xs" data-testid="meta-api-calls">
      <summary className="cursor-pointer text-slate-700">Chiamate API Meta per permesso</summary>
      <ul className="mt-1.5 space-y-1">{rows.map(({ permission: p, last: l }) => (
        <li key={p} className="flex flex-wrap items-center gap-1.5" data-testid={`meta-api-call-${p}`}>
          {!l ? <CircleDashed size={14} className="text-slate-400" /> : l.ok ? <CheckCircle2 size={14} className="text-emerald-600" /> : <XCircle size={14} className="text-red-600" />}
          <code className="text-slate-800">{p}</code>
          <span className="text-slate-500">{!l ? "nessuna chiamata ancora" : `${l.call} · ${formatDate(l.at, true)} · ${l.mode === "live" ? "Meta reale" : "emulata DEV"}${l.ok ? "" : ` · errore ${l.error}`}`}</span>
        </li>))}</ul>
    </details>);
}
